const resources: any = {
  Wa: 'Water',
  Cu: 'Copper',
  Fe: 'Iron',
  Ag: 'Silver',
  Au: 'Gold',
  Oil: 'Oil',
  Dia: 'Diamond',
  Ti: 'Titanium',
  Pt: 'Platinum',
  U: 'Uranium',
}

export const resourcesInverted: any = {
  Water: 'Wa',
  Copper: 'Cu',
  Iron: 'Fe',
  Silver: 'Ag',
  Gold: 'Au',
  Oil: 'Oil',
  Diamond: 'Dia',
  Titanium: 'Ti',
  Platinum: 'Pt',
  Uranium: 'U',
}

const resource_colors: any = {
  Wa: 'blue',
  Cu: 'orange',
  Fe: 'purple',
  Ag: 'grey',
  Au: 'yellow',
  Oil: 'olive',
  Dia: 'teal',
  Ti: 'pink',
  Pt: 'violet',
  U: 'red',
}

const resource_raw_colors: any = {
  Wa: '#2185d0',
  Cu: '#f2711c',
  Fe: '#a333c8',
  Ag: '#767676',
  Au: '#fbbd08',
  Oil: '#b5cc18',
  Dia: '#b5cc18',
  Ti: '#e61a8d',
  Pt: '#6435c9',
  U: '#db2828'
}

export const translateResource = (resource: any, inverse = false) => {
  if (inverse) return resourcesInverted[resource] || resource;
  return resources[resource] || resource
}

export const translateResourceColor = (resource: any) => {
  return resource_colors[resource]
}

export const translateResourceColorRaw = (resource: any) => {
  return resource_raw_colors[resource]
}
